import Vue from 'vue'
import App from './micro-dashboard.vue'

new Vue({
  render: h => h(App),
}).$mount('#micro-dashboard')
